import { render, staticRenderFns } from "./salesperson_header.vue?vue&type=template&id=7ae2a336&scoped=true&"
import script from "./salesperson_header.vue?vue&type=script&lang=js&"
export * from "./salesperson_header.vue?vue&type=script&lang=js&"
import style0 from "./salesperson_header.vue?vue&type=style&index=0&id=7ae2a336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae2a336",
  null
  
)

export default component.exports